import { AutogenModelEdiremitProfile, AutogenRowEdiremitProfile } from "./autogen/AutogenModelEdiremitProfile";

export class ModelEdiremitProfile extends AutogenModelEdiremitProfile<RowEdiremitProfile> {
	constructor() {
		super(RowEdiremitProfile);
	}
}

export class RowEdiremitProfile extends AutogenRowEdiremitProfile {
}